import { path } from 'utils'
import { z } from 'zod'

import { OperationLevelPermission } from '../auth-claims/permissions'
import { defineApi } from '../http'

export enum ExportType {
  /**
   * For exporting CFF structure from All Fields page. This is the default
   * functionality of the endpoint if an export type is not given.
   */
  Uploaded = 'uploaded',
  /**
   * For exporting CFF structure from the Manage Operation > Planning > Fields page.
   */
  Planned = 'planned'
}

/**
 * Account config file download API, for downloading a 2020 file
 * that contains the client-farm-field structure of the operation.
 */
export const cffConfigFileDownloadApi = defineApi({
  pathSchema: z.object({
    orgCode: z.string()
  }),
  pathFor: (params) => {
    return path(`/account/${params.orgCode}/export`, {
      type: params.exportType ?? ExportType.Uploaded
    })
  },
  querySchema: z.object({
    exportType: z.enum(ExportType).optional()
  }),
  name: 'ExportFieldStructure',
  description:
    'Export client/farm/field structure as a 2020 config file for uploaded or planned fields',
  requiredPermissions: OperationLevelPermission.ExportData,
  responseSchema: z.object({
    url: z.string()
  }),
  gatewayPath: '/account/:orgCode/export' as const
})
